import React from 'react';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  TB_PORTAL_WEBSITE_ROUTE,
  TEENYEBEANS_PORTAL_ROUTE_PREFIX,
} from '../../routes/routes';

// Styling mirrors the Atheneum side nav (containers/Atheneum/SideNavBar.jsx).
const linkStyle = {
  height: 64,
  paddingLeft: 16,
  paddingRight: 16,
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 4,
};

const useStyles = makeStyles((theme) => ({
  overAll: { height: 510, paddingLeft: 5, paddingRight: 5 },
  linkStyle: {
    ...linkStyle,
  },
  linkStyleActive: {
    ...linkStyle,
    backgroundColor: theme.palette.buzzActiveLinkBackground,
  },
  textStyle: {
    textDecoration: 'none',
  },
}));

const TeenybeansSideNavBar = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const theme = useTheme();

  // Schools stays on the bare module URL so every existing link to it keeps working.
  const paths = [
    {
      name: 'Schools',
      link: TEENYEBEANS_PORTAL_ROUTE_PREFIX,
    },
    {
      name: 'Website Builder',
      link: TB_PORTAL_WEBSITE_ROUTE,
    },
  ];

  return (
    <Box
      flex={2}
      mr={3}
      border={1}
      borderColor={theme.palette.buzzBorder}
      borderRadius={4}
      className={classes.overAll}>
      {paths.map((path) => {
        const isActive = pathname === path.link;
        return (
          <Link
            key={path.name}
            to={path.link}
            color="inherit"
            className={classes.textStyle}>
            <Box
              className={isActive ? classes.linkStyleActive : classes.linkStyle}
              display="flex"
              alignItems="center">
              <Box flexGrow={1}>
                <Typography color="textPrimary" component="div">
                  <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                    {path.name}
                  </Box>
                </Typography>
              </Box>
              {isActive && <ChevronRightIcon color="primary" />}
            </Box>
          </Link>
        );
      })}
    </Box>
  );
};

export default TeenybeansSideNavBar;
